"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const unified_1 = require("unified");
const remark_parse_1 = __importDefault(require("remark-parse"));
const remark_html_1 = __importDefault(require("remark-html"));
// takes a string of markdown and HTML from an airtable
// rich text field and returns a string of html
const parseCMSRichText = (string) => String((0, unified_1.unified)().use(remark_parse_1.default).use(remark_html_1.default, { sanitize: false }).processSync(string));
exports.default = parseCMSRichText;
//# sourceMappingURL=parseCMSRichText.js.map